import { Icon } from '../../ui/bootstrap/bootstrap'

import styles from './RecipeTime.sass'

// When used as a draft-js decorator, children carry the editable
// text and have to be rendered as-is.
export const RecipeTime = ({ time, unit, children }) =>
  <span className={styles.time}>
    <span contentEditable={false}>
      <Icon icon="clock" />
      {' '}
    </span>
    {children || `${time} ${unit}`}
  </span>
